<template>
  <div>
    <h1>{{ $t("exchangeRate.title") }}</h1>
    <delegation-info-menu></delegation-info-menu>
    <v-row style="margin-bottom: 15px">
      <v-col cols="4" class="">
        <v-row no-gutters>
          <v-col>
            <date-picker
              :placeholder="$t('global.any')"
              prependIcon="fa-calendar"
              :model.sync="date"
              class="mr-2"
              :clearable="true"
              :label="toDate == null ? $t('exchangeRate.date') : $t('exchangeRate.fromDate')"
            />
          </v-col>
          <v-col>
            <date-picker :placeholder="$t('global.any')" prependIcon="fa-calendar" :model.sync="toDate" :label="$t('exchangeRate.toDate')" :clearable="true" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="2">
        <v-autocomplete
          prependIcon="attach_money"
          :label="$t('exchangeRate.currency')"
          v-model="selectedCurrency"
          :placeholder="$t('global.any')"
          :items="currencyList"
          hide-details
          multiple
        ></v-autocomplete>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="filteredItems"
      :search="search"
      :loading="loading"
      must-sort
      :sort-by.sync="pagination.sortBy"
      :sort-desc.sync="pagination.descending"
      :footer-props="{ 'items-per-page-options': [5, 10, 25] }"
    >
      <template #item="props">
        <tr>
          <td class="text-left">{{ props.item.currency_code }}</td>
          <td class="text-left">{{ props.item.effective_date }}</td>
          <td class="text-left">{{ props.item.mid }}</td>
          <td class="text-left">NBP</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import DelegationInfoMenu from "../../components/DelegationInfoMenu.vue";
import DatePicker from "../../components/CustomInputComponents/DatePicker";

export default {
  name: "DelegationInfoExchangeRateView",
  components: { DatePicker, DelegationInfoMenu },
  data: () => ({
    search: "",
    items: [],
    loading: true,
    pagination: { sortBy: "effective_date", descending: true },
    selectedCurrency: [],
    date: null,
    toDate: null
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t("exchangeRate.headers.currency"),
          value: "currency_code",
          sortable: false
        },
        {
          text: this.$t("exchangeRate.headers.date"),
          value: "effective_date",
          sortable: true
        },
        { text: this.$t("exchangeRate.headers.rate"), value: "mid" },
        { text: this.$t("exchangeRate.headers.source"), value: "source" }
      ];
    },
    currencyList() {
      let result = [];
      for (let currencyRow of this.items) {
        if (!result.includes(currencyRow.currency_code)) {
          result.push(currencyRow.currency_code);
        }
      }
      return result;
    },
    filteredItems() {
      let result = this.items;
      if (this.selectedCurrency.length > 0) {
        result = result.filter(v => this.selectedCurrency.includes(v.currency_code));
      }
      if (this.date != null) {
        if (this.toDate != null) {
          result = result.filter(v => v.effective_date >= this.date);
        } else {
          result = result.filter(v => v.effective_date === this.date);
        }
      }
      if (this.toDate != null) {
        result = result.filter(v => v.effective_date <= this.toDate);
      }
      return result;
    }
  },
  created() {
    const self = this;
    this.axios.get("exchange-rate/list").then(result => {
      self.items = result.data;
      self.loading = false;
    });
  }
};
</script>

<style scoped></style>
